import { DirectDebitAccount } from '@app/entities/models/ptrab/payslips/direct-debit-account.model';

export class DirectDebit {
  code?: string;
  employeeNumber?: string;
  companyName?: string;
  account?: DirectDebitAccount;
}
